export default "__VITE_ASSET__be378bb8__"